import { render, staticRenderFns } from "./riskControlDetail.vue?vue&type=template&id=6f68bd70&scoped=true"
import script from "./riskControlDetail.vue?vue&type=script&lang=js"
export * from "./riskControlDetail.vue?vue&type=script&lang=js"
import style0 from "./riskControlDetail.vue?vue&type=style&index=0&id=6f68bd70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f68bd70",
  null
  
)

export default component.exports